"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCircularArray = void 0;
const react_1 = require("react");
// TODO Philou: one day use real circular array with node and next pointer but this thing got ship
const useCircularArray = (values, defaultValue) => {
    const [array, setArray] = (0, react_1.useState)([...values]);
    const [currentValue, setCurrentValue] = (0, react_1.useState)(values[0]);
    const [nextValue, setNextValue] = (0, react_1.useState)(values[1]);
    (0, react_1.useEffect)(() => {
        setCurrentValueByValue(defaultValue);
    }, [defaultValue]);
    const next = () => {
        const copiedArray = [...array];
        const currentValue = copiedArray.shift();
        copiedArray.push(currentValue);
        setArray([...copiedArray]);
        setCurrentValue(copiedArray[0]);
        setNextValue(copiedArray[1]);
    };
    const setCurrentValueByValue = (value) => {
        const indexOfValue = array.indexOf(value);
        if (indexOfValue >= 0) {
            const copiedArray = [...array];
            for (let i = 0; i < indexOfValue; i++) {
                const currentValue = copiedArray.shift();
                copiedArray.push(currentValue);
            }
            setArray([...copiedArray]);
            setCurrentValue(copiedArray[0]);
            setNextValue(copiedArray[1]);
        }
    };
    return {
        currentValue,
        nextValue,
        next,
        setCurrentValueByValue,
    };
};
exports.useCircularArray = useCircularArray;
//# sourceMappingURL=useCircularArray.js.map